"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { useMemo as p, useCallback as u } from "react";
import { t as f } from "./tv.config-BuYIgndg.mjs";
import { useTimelineContext as x } from "./TimelineContext.js";
import g from "./Card.js";
import h from "./CardContent.js";
import b from "./Box.js";
import l from "./Typography.js";
const v = f({
  slots: {
    root: [
      "Timeline__item-root",
      "relative",
      "flex",
      "items-center",
      "justify-between",
      "md:justify-normal",
      "md:odd:flex-row-reverse",
      "group"
      // "is-active", //This can be applied conditionally
    ],
    icon: [
      "Timeline__item-icon",
      "flex",
      "items-center",
      "justify-center",
      "size-8",
      "rounded-full",
      "shadow",
      "shrink-0",
      "md:order-1",
      "md:group-odd:-translate-x-1/2",
      "md:group-even:translate-x-1/2",
      // "border-white",
      "bg-gray-200",
      "text-gray-700"
      // "group-[.is-active]:bg-indigo-100",
      // "group-[.is-active]:text-primary-main",
      // "counter-increment", //This can be applied conditionally
    ],
    card: [
      "Timeline__item-card",
      "w-[calc(100%-3rem)]",
      "md:w-[calc(50%-32px)]"
    ],
    content: [
      "flex",
      "items-center",
      "justify-between",
      "space-x-2",
      "md:group-even:flex-row-reverse"
    ],
    title: ["font-bold text-slate-900"],
    time: ["font-caveat", "font-medium", "text-primary-light"],
    description: ["text-slate-500", "md:group-even:text-right"]
  },
  variants: {
    orientation: {
      horizontal: "",
      vertical: ""
    },
    isNumeric: {
      true: {
        icon: ["counter-increment"],
        root: ["is-active"]
      }
    },
    isConnected: {
      true: {
        card: [
          "before:absolute",
          "before:w-6",
          "before:h-px",
          "before:bg-gray-200",
          "md:before:group-odd:-translate-x-1/2",
          "md:before:group-even:translate-x-1/2",
          "md:before:group-odd:left-1/2",
          "md:before:group-odd:ml-5",
          "md:before:group-even:right-1/2",
          "md:before:group-even:mr-5",
          "md:before:top-1/2",
          "md:before:-translate-y-1/2"
        ]
      }
    }
  }
}), {
  root: C,
  icon: j,
  card: I,
  content: w,
  title: T,
  time: y,
  description: N
} = v(), _ = (n) => {
  const { className: s, orientation: t, isNumeric: r, ...i } = n, o = p(
    () => C({
      orientation: t,
      isNumeric: r,
      className: s
    }),
    [t, s]
  );
  return { getTimelineItemProps: u(
    (m = {}) => ({
      className: o,
      role: "timeline",
      "data-orientation": t,
      isNumeric: r,
      ...i,
      ...m
    }),
    [o, t, r, i]
  ) };
}, S = (n) => {
  const { getTimelineItemProps: s } = _(n), {
    as: t = "div",
    title: r,
    description: i,
    time: o,
    isNumeric: a,
    icon: m,
    ...c
  } = s(), { variant: P, isConnected: d } = x();
  return /* @__PURE__ */ e.jsxs(t, { ...c, children: [
    /* @__PURE__ */ e.jsx("div", { className: j({ isNumeric: a }), children: m && /* @__PURE__ */ e.jsx(
      "svg",
      {
        className: "fill-current",
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "10",
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fillRule: "nonzero",
            d: "M10.422 1.257 4.655 7.025 2.553 4.923A.916.916 0 0 0 1.257 6.22l2.75 2.75a.916.916 0 0 0 1.296 0l6.415-6.416a.916.916 0 0 0-1.296-1.296Z"
          }
        )
      }
    ) }),
    /* @__PURE__ */ e.jsx(
      g,
      {
        className: I({
          isConnected: d
        }),
        outlined: !0,
        children: /* @__PURE__ */ e.jsxs(h, { children: [
          /* @__PURE__ */ e.jsxs(b, { className: w({}), children: [
            /* @__PURE__ */ e.jsx(l, { component: "h6", className: T({}), children: r || "Title" }),
            o && /* @__PURE__ */ e.jsx(
              l,
              {
                component: "time",
                className: y({}),
                children: o || "08/06/2023"
              }
            )
          ] }),
          i && /* @__PURE__ */ e.jsx(l, { className: N({}), children: i })
        ] })
      }
    )
  ] });
};
export {
  S as default
};
